var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataLevel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 46.249 44.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x38_9",
    transform: "translate(-2.1 -3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19279",
    "data-name": "Path 19279",
    d: "M48.349,21.758a9.56,9.56,0,0,0-9.569-9.569h-.652a10.642,10.642,0,0,0-20.442-2.175,6.922,6.922,0,0,0-9.5,6.452v.58A7.182,7.182,0,0,0,9.277,31.327h2.61v7.612H7.972a2.908,2.908,0,1,0-2.827,3.625,2.957,2.957,0,0,0,2.827-2.175h4.639a.685.685,0,0,0,.725-.725v-1.45H19.5v3.915a2.908,2.908,0,1,0,3.625,2.827,2.957,2.957,0,0,0-2.175-2.827V37.488a.685.685,0,0,0-.725-.725H13.336V31.327h6.6A12.19,12.19,0,0,0,44.29,30.6a4.786,4.786,0,0,0-.072-1.015A9.406,9.406,0,0,0,48.349,21.758ZM5.29,41.185a1.45,1.45,0,1,1,1.45-1.45A1.454,1.454,0,0,1,5.29,41.185Zm16.455,3.77a1.45,1.45,0,1,1-1.45-1.45A1.454,1.454,0,0,1,21.745,44.955ZM32.111,41.33A10.729,10.729,0,1,1,42.84,30.6,10.7,10.7,0,0,1,32.111,41.33ZM44,27.992a12.187,12.187,0,0,0-24.067,1.885H9.277a5.729,5.729,0,0,1-.217-11.454.655.655,0,0,0,.652-.8,5.487,5.487,0,0,1-.072-1.087,5.471,5.471,0,0,1,8.119-4.784.774.774,0,0,0,1.087-.435,9.113,9.113,0,0,1,8.844-6.6A9.227,9.227,0,0,1,36.9,13.131a.716.716,0,0,0,.87.652,5.859,5.859,0,0,1,1.16-.072,8.106,8.106,0,0,1,8.119,8.119A8.867,8.867,0,0,1,44,27.992Z",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19283",
    "data-name": "Path 19283",
    d: "M45.874,34.292h-.507V33.2a4.2,4.2,0,0,0-8.409,0v1.087H36.45A1.454,1.454,0,0,0,35,35.742v7.9a1.454,1.454,0,0,0,1.45,1.45h9.424a1.454,1.454,0,0,0,1.45-1.45v-7.9a1.454,1.454,0,0,0-1.45-1.45ZM38.407,33.2a2.755,2.755,0,0,1,5.509,0v1.087H38.335ZM36.45,43.643v-7.9h9.424v7.9Z",
    transform: "translate(-9.05 -7.097)",
    fill: "#212832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19284",
    "data-name": "Path 19284",
    d: "M42.62,39.6a2.29,2.29,0,0,0-2.32,2.32,2.262,2.262,0,0,0,1.595,2.175v.8a.725.725,0,0,0,1.45,0v-.8a2.262,2.262,0,0,0,1.595-2.175A2.336,2.336,0,0,0,42.62,39.6Zm0,3.117a.881.881,0,0,1-.87-.87.87.87,0,1,1,1.74,0A.881.881,0,0,1,42.62,42.717Z",
    transform: "translate(-10.508 -10.013)",
    fill: "#212832"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLevel);
export default __webpack_public_path__ + "static/media/DataLevel.6569bd30cb3ef9e44a16a65bcee07ba6.svg";
export { ForwardRef as ReactComponent };